/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_FootnoteInputs */

const en_mk_context_footnote = /** @type {(inputs: Mk_Context_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All of this belongs to your workspace — edit or delete it anytime, and none of it is used to train anyone else's model.`)
};

const id_mk_context_footnote = /** @type {(inputs: Mk_Context_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua ini milik workspace-mu — bisa diedit atau dihapus kapan saja, dan tidak dipakai untuk melatih model siapa pun.`)
};

/**
* | output |
* | --- |
* | "All of this belongs to your workspace — edit or delete it anytime, and none of it is used to train anyone else's model." |
*
* @param {Mk_Context_FootnoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_footnote = /** @type {((inputs?: Mk_Context_FootnoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_FootnoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_footnote(inputs)
	return en_mk_context_footnote(inputs)
});